const defaultState = {
  listLoading: false,
  pageCount: 0,
  currentPageNumber: 0,
  entities: [],
  totalResult: 0,
  error: null,
};
export const actionTypes = {
  ordersFetched: 'ORDERS_FETCHED',
  ordersAppended: 'ORDERS_APPENDED',
  editPaid: 'EDIT_PAID',
  editTotalPayment: 'EDIT_TOTAL_PAYMENT',
  deleteOrder: 'DELETE_ORDER',
  freezeOrder: 'FREEZE_ORDER',
  unfreezeOrder: 'UNFREEZE_ORDER',
  catchError: 'CATCH_ERROR'
};

const getIndex = (array, orderID) => {
  const mappedArray = array.map(item => item.orderNumber);
  return mappedArray.indexOf(orderID);
};

export const ordersPageTableReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.ordersFetched: {
      const {totalPageCount, currentPageNumber, orders, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: orders,
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.ordersAppended: {
      const {totalPageCount, currentPageNumber, orders, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: state.entities
          ? [...state.entities, ...orders]
          : [...orders],
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.editPaid: {
      const {orderID, paid} = action.payload;
      const index = getIndex(state.entities, orderID);
      state.entities[index].paid = paid;
      return {
        ...state,
        entities: [...state.entities]
      };
    }
    case actionTypes.editTotalPayment: {
      const {orderID, totalPayment} = action.payload;
      const index = getIndex(state.entities, orderID);
      state.entities[index].totalPayment = totalPayment;
      return {
        ...state,
        entities: [...state.entities]
      };
    }
    case actionTypes.deleteOrder: {
      const {orderID} = action.payload;
      const index = getIndex(state.entities, orderID);
      state.entities.splice(index, 1)
      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.freezeOrder: {
      const {orderID} = action.payload;
      const index = getIndex(state.entities, orderID);
      state.entities[index].status = 4;
      return {
        ...state,
        entities: [...state.entities]
      };
    }
    case actionTypes.unfreezeOrder: {
      const {orderID, status} = action.payload;
      const index = getIndex(state.entities, orderID);
      state.entities[index].status = status;
      return {
        ...state,
        entities: [...state.entities]
      };
    }
    case actionTypes.catchError: {
      const error = `ORDERS: ${action.payload.error}`;
      return {...state, error};
    }
    default: return state;
  }
};

export const actions = {
  ordersFetched: (data) => ({
    type: actionTypes.ordersFetched,
    payload: data
  }),
  ordersAppended: (data) => ({
    type: actionTypes.ordersAppended,
    payload: data
  }),
  editPaid: (data) => ({
    type: actionTypes.editPaid,
    payload: data
  }),
  editTotalPayment: (data) => ({
    type: actionTypes.editTotalPayment,
    payload: data
  }),
  deleteOrder: (data) => ({
    type: actionTypes.deleteOrder,
    payload: data
  }),
  freezeOrder: (data) => ({
    type: actionTypes.freezeOrder,
    payload: data
  }),
  unfreezeOrder: (data) => ({
    type: actionTypes.unfreezeOrder,
    payload: data
  }),
  catchError: (error) => ({type: actionTypes.catchError, payload: {error}}),
};
